import { useRouter } from 'next/router'

import { Bag, ScreenReaderOnly } from '@syconium/little-miss-figgy'

import { CartItemCountBadge } from '../../../app/_components/chrome/PrimaryNavCart.client'
import { useCartDialog } from '../../../app/_providers/CartProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { NavTab } from '../../../types/graphql'

import { CartButtonWrapper } from './styles'

export function useCartTab(): NavTab {
  const {
    magnolia: { navigation: strings },
  } = useTranslation()
  const { open: openCartDialog } = useCartDialog()
  const { pathname } = useRouter()

  const isCartPage: boolean = pathname === '/cart'

  const cartTab: NavTab = {
    __typename: 'NavTab',
    ariaLabel: strings.cartButtonAriaLabel,
    href: null,
    id: 'cart',
    onClickish: () => {
      if (isCartPage) return
      openCartDialog()
    },
    render: () => (
      <CartButtonWrapper>
        <Bag aria-hidden='true' />
        <ScreenReaderOnly>{strings.cartButtonAriaLabel}</ScreenReaderOnly>
        <CartItemCountBadge />
      </CartButtonWrapper>
    ),
    sections: [],
    text: '',
    textColor: null,
    wrapperElement: 'button',
    alternateModelVariant: null,
  }

  return cartTab
}
